import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { HttpParams } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { ChangeScanModeResponse } from '@enums/changeScanModeResponse.enum';
import { RfidCard } from '@models/rfidCard';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { RfidCardsService } from '@services/entity/rfidCards.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-rfid-scan-dialog-content',
  templateUrl: './rfid-scan-dialog-content.component.html',
  styleUrls: ['./rfid-scan-dialog-content.component.scss']
})
export class RfidScanDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'RfidScanDialogContentComponent';

  public form: UntypedFormGroup;
  public formCreated: boolean;
  public chargingStations: ChargingStationDto[];
  public customerId: number;
  public scannedRfidTag: string;
  private modalActive: boolean;
  private currentScanningChargingStationId: string;

  constructor(
    public activeModal: NgbActiveModal,
    private chargingStationsService: ChargingStationsService,
    private rfidCardsService: RfidCardsService,
    private toastService: ToastService,
    injector: Injector) {
      super(activeModal, injector);
  }

  ngOnInit(): void {
    this.modalActive = true;
    this.loadEntities();
  }

  loadEntities() {
    if (this.customerId) {
      this.chargingStationsService.getChargingStationsOfCustomer(this.customerId).subscribe(result => {
        this.chargingStations = result;
        this.chargingStationSortByName();
        this.createForm();
      }, error => { })
    }
    else {
      this.chargingStationsService.getChargingStationsOfCurrentCustomer().subscribe(result => {
        this.chargingStations = result;
        this.chargingStationSortByName();
        this.createForm();
      }, error => { })
    }
  }

  chargingStationSortByName() {
    this.chargingStations = this.chargingStations.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    })
  }


  createForm() {
    this.form = new UntypedFormGroup({
      selectedChargingStationId: new UntypedFormControl(),
      isScanModeActive: new UntypedFormControl(false)
    });

    this.formCreated = true;
  }

  changeChargingStation(chargingStation: ChargingStationDto) {
    var isScanModeActive = this.chargingStations.find(c => c.id == chargingStation.id).isScanModeActive;
    this.form.get('isScanModeActive').setValue(isScanModeActive);

    if (isScanModeActive) {
      this.getScannerInput(chargingStation.id);
    }
  }

  scanActiveChanged() {
    var chargingStationId = this.form.get('selectedChargingStationId').value;
    var isScanModeActive = this.chargingStations.find(c => c.id == chargingStationId).isScanModeActive;
    var newMode = !isScanModeActive;

    this.chargingStationsService.changeScannerMode(chargingStationId, newMode).subscribe(result => {
      if (result == ChangeScanModeResponse.Success) {
        this.form.get('isScanModeActive').setValue(newMode);
        if (newMode == true) {
          this.getScannerInput(chargingStationId);
        }
      }
    }, error => {
      this.toastService.error('RFID Karte konnte nicht angelegt werden.');

    })
  }

  getScannerInput(id: string) {
    this.currentScanningChargingStationId = id;
    this.chargingStationsService.getScannerInput(id).subscribe(result => {
      this.messageService.clearSuccess();
      this.messageService.clearErrors();
      this.scannedRfidTag = result.idTag;

      var selectedChargingStationId = this.form.get('selectedChargingStationId').value;

      if (!result.idTag && this.modalActive && selectedChargingStationId == this.currentScanningChargingStationId) {
        this.getScannerInput(id);
      }
    }, error => {
      this.toastService.error('RFID Karte konnte nicht angelegt werden.');

      console.error(error);
    })
  }

  createRfidCard() {
    var rfidCard = new RfidCard();
    rfidCard.idTag = this.scannedRfidTag.replace(/\s/g, "")
      .replace(/[':]+/g, '')
      .replace(/[^a-fA-F0-9]/g, '')
      .toLowerCase();

    if (this.customerId) {
      this.rfidCardsService.createRfidCardForCustomer(this.customerId, rfidCard).subscribe(result => {
        this.scannedRfidTag = undefined;
        var chargingStationId = this.form.get('selectedChargingStationId').value;
        this.getScannerInput(chargingStationId);
        this.toastService.success('RFID Karte wurde angelegt.');
      }, error => {
        this.toastService.error('RFID Karte konnte nicht angelegt werden.');
      });
    }
    else {
      this.rfidCardsService.createEntity(rfidCard).subscribe(result => {
        this.scannedRfidTag = undefined;
        var chargingStationId = this.form.get('selectedChargingStationId').value;
        this.getScannerInput(chargingStationId);
        this.toastService.success('RFID Karte wurde angelegt.');
      }, error => {
        this.toastService.error('RFID Karte konnte nicht angelegt werden.');
      });
    }

  }

  onCancelClick() {
    this.modalActive = false;

    this.chargingStations.forEach(c => {
      this.chargingStationsService.changeScannerMode(c.id, false).subscribe(result => {})
    })

    this.activeModal.close();
  }

}
